import { AcceptPolicyResponse } from '../../api/hub-responses/accept-policy-response';
import { HubApiError } from '../../domains/valueObject/SwitchUserProgressResponses';
import { getHubApi } from '../modules/accountServiceApi/getAccountServiceApi';


export type AcceptPolicyRequest = {
    suid: string,
    policy_ids: number[]
    token: string
}

export function acceptPolicy(data: AcceptPolicyRequest): Promise<AcceptPolicyResponse|HubApiError> {
    const hubApi = getHubApi();
    return hubApi.acceptPolicy(window.app.deviceIdentifier, data) as Promise<AcceptPolicyResponse>;
}
